module.exports = __webpack_public_path__ + "static/img/14000317.385d2eff.png";